import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Col, Row, Spin, Table, message } from 'antd';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';

import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';

import { NumberField } from '../../atoms';
import FuelUnit from './FuelUnit';
import MeasurementPointGhgTable from './MeasurementPointGhgTable';
import addInitialFuels from './addInitialFuels';
import './AddEquipmentFuelsUsed.css';

import { tAddEquipment } from '../../i18n';
import { getLocale } from '../../reducers/settingsReducer';

import { getLoadingSelector } from '../../utils/asyncHelpers';
import { getLoadingUnitFuels } from '../../reducers/loadingUnitFuelsReducer';

import { productionUnitFields } from '../../constants/productionUnit';

import {
  FORM_FUELS_USED,
  fuelsUsedFormFields,
  issuedGosStatus,
} from '../../constants/formsAddEquipment';

import {
  updateFuelsWithDelete,
  requestProductionUnitUpdate,
  fetchFeedstockAndProductionPathwayClassifiers,
  fetchAndEditProductionUnitNoHistory,
} from '../../actions/actionCreators/productionUinitActionCreators';

import {
  fetchHydrogenFuelDataForProductionPeriod,
  issueHydrogenGos,
} from '../../actions/actionCreators/productionUnitAddActionCreators';

import {
  fetchHydrogenMeasurementDataForProductionPeriod,
  fetchHydrogenGosIssued,
  resetHydrogenGosIssued,
} from '../../actions/actionCreators/equipmentAddHydrogenMeasurementDataActionCreators';

import {
  confirmHydrogenFuelData,
  productionUnitMonthlyAggregatedDataFetch,
  productionUnitConfirmAllMeasurementPointAmounts,
  saveHydrogenFuelData,
} from '../../actions/actionHelpers/endpoints';
import dayjs from '../../utils/dayjs';

import { getHydrogenFuelData } from '../../reducers/productionUnitHydrogenFuelReducer';

import {
  getHydrogenMeasurementData,
  getIsGosIssued,
} from '../../reducers/equipmentAddMeasurementDataReducer';

import { RegisterActions } from '../../components';
import FuelsUsedHistory from './FuelsUsedHistory';
import { Link } from 'react-router-dom';

import FormStateToRedux from '../FormStateToRedux';
import {
  formValueSelector,
  updateFormState,
  getRffFormValues,
} from '../../reducers/reactFinalFormReducer';
import { isEqual } from 'lodash/fp';
import SubmitErrorToast from '../SubmitErrorToast';

const getUsedFuels = (values) => {
  const list = values?.[fuelsUsedFormFields.TYPES] || [];
  return list
    .filter((item) => item?.[fuelsUsedFormFields.IS_FUEL_USED])
    .map(({ _tempKey, ...rest }) => rest); // Strip internal _tempKey field
};

export class AddEquipmentFuelsUsed extends Component {
  static propTypes = {
    isHydrogenContext: PropTypes.bool.isRequired,
    hasPrevious: PropTypes.bool,
    hasDone: PropTypes.bool,
    goPrevious: PropTypes.func,
    productionUnit: PropTypesImmutable.map.isRequired,
    totalPercentage: PropTypes.number.isRequired,
    inEditForNotAdmin: PropTypes.bool.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    showRequestChangeModal: PropTypes.func,
    fetchHydrogenFuelDataForProductionPeriod: PropTypes.func.isRequired,

    // mirrored form values
    hydrogenHigherValue: PropTypes.any,
    hydrogenLowerValue: PropTypes.any,
    hydrogenChgIntensity: PropTypes.any,

    // data & loading
    initialValues: PropTypesImmutable.map.isRequired,
    savedFormValues: PropTypes.object,
    locale: PropTypes.string,
    isLoading: PropTypes.bool.isRequired,
    hydrogenFuelData: PropTypesImmutable.map,
    measurementData: PropTypesImmutable.map,
    gosStatus: PropTypes.string,

    // actions
    fetchClassifiers: PropTypes.func.isRequired,
    fetchHydrogenMeasurementDataForProductionPeriod: PropTypes.func.isRequired,
    isGosIssued: PropTypes.func.isRequired,
    issueHydrogenGos: PropTypes.func.isRequired,
    resetGosIssued: PropTypes.func.isRequired,
    updateFuelsWithDelete: PropTypes.func.isRequired,
    requestProductionUnitUpdate: PropTypes.func.isRequired,
    fetchProductionUnit: PropTypes.func.isRequired,
    updateFormState: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func,
    t: PropTypes.func.isRequired,
  };

  state = {
    // Track the current status after save (overrides prop value)
    currentStatus: null,
    saving: false,
    allMpAggregatedData: [],
    allMpDataLoading: false,
  };

  getStatus = () => {
    const { fuels, isHydrogenContext, hydrogenFuelData, productionUnit } =
      this.props;

    // If we have a status in state (after save), use that
    if (this.state.currentStatus !== null) {
      return this.state.currentStatus;
    }

    if (isHydrogenContext) {
      if (hydrogenFuelData) {
        return hydrogenFuelData.get('status');
      }
    } else {
      // Read status from production unit data
      const productionUnitFuels = productionUnit.get(
        productionUnitFields.FUEL_TYPES
      );
      if (productionUnitFuels && productionUnitFuels.size > 0) {
        const fuelStatus = productionUnitFuels.get(0).get('status');
        if (!fuelStatus) return 'OPEN';
        return fuelStatus;
      }
      // Fallback to form state if production unit doesn't have fuels yet
      if (!!fuels && fuels.size > 0) {
        const fuelStatus = fuels.get(0).get('status');
        if (!fuelStatus) return 'OPEN';
        return fuelStatus;
      }
    }
    return null;
  };

  saveHydrogenFuelData = async () => {
    const {
      isHydrogenContext,
      hydrogenFuelData,
      hydrogenHigherValue,
      hydrogenLowerValue,
      hydrogenChgIntensity,
      isAdmin,
      t,
      gosStatus,
    } = this.props;
    if (isHydrogenContext) {
      if (!hydrogenHigherValue || !hydrogenLowerValue) {
        message.error(t('fuelsUsed.hydrogenFieldError'));
        return;
      }
      if (!hydrogenChgIntensity) {
        message.error(t('productionUnitFuelChgIntensityEmpty'));
        return;
      }
    }
    const productionUnitId = hydrogenFuelData.get('productionUnit');
    const year = hydrogenFuelData.get('year');
    const month = hydrogenFuelData.get('month');

    const postData = {
      productionUnit: productionUnitId,
      lowerCalorificValue: hydrogenLowerValue,
      higherCalorificValue: hydrogenHigherValue,
      chgIntensity: String(hydrogenChgIntensity),
      year: year,
      month: month,
      status: hydrogenFuelData.get('status'),
    };

    if (
      isAdmin &&
      (hydrogenFuelData.get('status') === 'PENDING' ||
        (hydrogenFuelData.get('status') === 'CONFIRMED' &&
          gosStatus === issuedGosStatus.FAIL))
    ) {
      await confirmHydrogenFuelData(postData);
    } else {
      await saveHydrogenFuelData(postData);
    }
  };

  updateHydrogenFuelDataAndGoNext = async () => {
    const { onSubmitSuccess } = this.props;
    try {
      await this.updateHydrogenFuelData();
    } catch (e) {
      console.error(e);
    }
    onSubmitSuccess?.();
  };

  updateHydrogenFuelData = async () => {
    const {
      hydrogenFuelData,
      fetchHydrogenFuelDataForProductionPeriod,
      fetchHydrogenMeasurementDataForProductionPeriod,
    } = this.props;

    const productionUnitId = hydrogenFuelData.get('productionUnit');
    const year = hydrogenFuelData.get('year');
    const month = hydrogenFuelData.get('month');

    this.setState({ saving: true });
    try {
      await this.saveHydrogenFuelData();
      await Promise.all([
        fetchHydrogenFuelDataForProductionPeriod({
          productionUnitId,
          year,
          month,
        }),
        fetchHydrogenMeasurementDataForProductionPeriod({
          productionUnitId,
          year,
          month,
        }),
      ]);
      this.issueGos(productionUnitId, year, month);
    } finally {
      this.setState({ saving: false });
    }
  };

  fetchAllMpAggregatedData = async () => {
    const { productionUnit } = this.props;
    const productionUnitId = productionUnit.get(productionUnitFields.ID);
    const month = dayjs().subtract(1, 'month').month() + 1;
    const year = dayjs().subtract(1, 'month').year();

    if (!productionUnitId) return;

    this.setState({ allMpDataLoading: true });
    try {
      const response = await productionUnitMonthlyAggregatedDataFetch({
        productionUnitId,
        year,
        month,
      });
      this.setState({ allMpAggregatedData: response?.data || [] });
    } catch (e) {
      console.error('Failed to fetch aggregated data', e);
      this.setState({ allMpAggregatedData: [] });
    } finally {
      this.setState({ allMpDataLoading: false });
    }
  };

  confirmAllMeteringPointAmounts = async () => {
    const { productionUnit } = this.props;
    const productionUnitId = productionUnit.get(productionUnitFields.ID);
    const month = dayjs().subtract(1, 'month').month() + 1;
    const year = dayjs().subtract(1, 'month').year();

    await productionUnitConfirmAllMeasurementPointAmounts({
      productionUnitId,
      year,
      month,
    });

    await this.fetchAllMpAggregatedData();
  };

  issueGos = async (productionUnitId, year, month) => {
    const { isGosIssued, hydrogenFuelData, measurementData, issueHydrogenGos } =
      this.props;

    if (
      hydrogenFuelData.get('status') === 'CONFIRMED' &&
      measurementData.get('status') === 'CONFIRMED'
    ) {
      await issueHydrogenGos({ productionUnitId, year, month });

      isGosIssued({
        productionUnitId,
        month,
        year,
      });
    }
  };

  componentDidUpdate(prevProps) {
    const { productionUnit, isHydrogenContext } = this.props;
    if (
      !isHydrogenContext &&
      productionUnit.get(
        productionUnitFields.ACTIVE_MEASUREMENT_POINT_COUNT
      ) !==
        prevProps.productionUnit.get(
          productionUnitFields.ACTIVE_MEASUREMENT_POINT_COUNT
        )
    ) {
      this.fetchAllMpAggregatedData();
    }
  }

  componentDidMount() {
    const {
      fetchHydrogenFuelDataForProductionPeriod,
      productionUnit,
      isHydrogenContext,
      fetchHydrogenMeasurementDataForProductionPeriod,
      isGosIssued,
      resetGosIssued,
      initialValues,
      updateFormState,
      fetchProductionUnit,
    } = this.props;

    const productionUnitId = productionUnit.get(productionUnitFields.ID);

    // Always re-fetch the production unit from DB to ensure fresh data
    if (productionUnitId) {
      fetchProductionUnit(productionUnitId);
    }

    updateFormState(FORM_FUELS_USED, { values: initialValues.toJS() });

    resetGosIssued();
    const month = dayjs().subtract(1, 'month').month() + 1;
    const year = dayjs().subtract(1, 'month').year();
    if (!isHydrogenContext) {
      this.fetchAllMpAggregatedData();
    } else {
      const productionUnitId = productionUnit.get(productionUnitFields.ID);
      fetchHydrogenFuelDataForProductionPeriod({
        productionUnitId,
        year,
        month,
      });
      fetchHydrogenMeasurementDataForProductionPeriod({
        productionUnitId,
        month,
        year,
      });
      isGosIssued({
        productionUnitId,
        month,
        year,
      });
    }
  }

  onSubmit = async (values) => {
    const {
      isHydrogenContext,
      totalPercentage,
      updateFuelsWithDelete,
      requestProductionUnitUpdate,
      onSubmitSuccess,
      isEditMode,
      isAdmin,
    } = this.props;

    if (isHydrogenContext) return;

    // In registration mode, if fuels already submitted, just advance
    if (!isEditMode) {
      const status = this.getStatus();
      if (status && status !== 'OPEN') {
        onSubmitSuccess?.();
        return;
      }
    }

    if (totalPercentage !== 100) {
      return { [FORM_ERROR]: tAddEquipment('fuelsUsed.percentageError') };
    }

    const arr = values?.[fuelsUsedFormFields.TYPES] || [];
    const isOpen = !!(
      arr[0] &&
      (arr[0].status === undefined || arr[0].status === 'OPEN')
    );

    const usedFuels = getUsedFuels(values);

    // Administrator confirming: GHG values are required, GOs are issued from them. They are checked
    // first, as they can be fixed in this form while unconfirmed amounts cannot.
    if (
      isEditMode &&
      isAdmin &&
      !isOpen &&
      this.state.allMpAggregatedData.length > 0
    ) {
      const activeMpIds = new Set(
        this.state.allMpAggregatedData.map((mp) => mp.measurementPointId)
      );
      const hasEmptyGhg = usedFuels.some((fuel) => {
        const ghgs =
          fuel[fuelsUsedFormFields.MEASUREMENT_POINT_FUEL_GHGS] || [];
        return ghgs
          .filter((g) => activeMpIds.has(g.measurementPointId))
          .some((g) => g.ghgIntensity == null || g.ghgIntensity === '');
      });
      if (hasEmptyGhg) {
        return {
          [FORM_ERROR]: tAddEquipment('productionUnitFuelChgIntensityEmpty'),
        };
      }

      const allConfirmed = this.state.allMpAggregatedData.every(
        (mp) => mp.confirmed
      );
      if (!allConfirmed) {
        return {
          [FORM_ERROR]: tAddEquipment('monthlyAggregatedDataNotConfirmed'),
        };
      }
    }

    const trimmedValues = { ...values, [fuelsUsedFormFields.TYPES]: usedFuels };

    let result;
    this.setState({ saving: true });
    try {
      const { fetchProductionUnit } = this.props;
      const productionUnitId = this.props.productionUnit.get(
        productionUnitFields.ID
      );

      if (!isOpen && isAdmin) {
        // Admin confirming: PENDING -> CONFIRMED
        result = await updateFuelsWithDelete(trimmedValues);
        if (!result?.error) {
          message.success(this.props.t('goSuccess'));
          if (productionUnitId) {
            await fetchProductionUnit(productionUnitId);
          }
          this.setState({ currentStatus: 'CONFIRMED' });
          this.fetchAllMpAggregatedData();
        }
      } else {
        // Manufacturer submitting: OPEN -> PENDING, or updating GHG values: PENDING -> PENDING
        result = await requestProductionUnitUpdate(trimmedValues);
        if (!result?.error) {
          onSubmitSuccess?.();
          if (productionUnitId) {
            await fetchProductionUnit(productionUnitId);
          }
          this.setState({ currentStatus: 'PENDING' });
        }
      }
    } finally {
      this.setState({ saving: false });
    }
  };

  render() {
    const {
      hasPrevious,
      hasDone,
      goPrevious,
      t,
      productionUnit,
      fetchClassifiers,
      isLoading,
      locale,
      totalPercentage,
      inEditForNotAdmin,
      isEditMode,
      isAdmin,
      showRequestChangeModal,
      isHydrogenContext,
      hydrogenFuelData,
      hydrogenLowerValue,
      hydrogenHigherValue,
      hydrogenChgIntensity,
      gosStatus,
      initialValues,
    } = this.props;

    const { saving, allMpAggregatedData, allMpDataLoading } = this.state;

    const status = this.getStatus();

    const isOpen = status === 'OPEN' || (isAdmin && status === 'PENDING');

    // Check if KHG values have already been saved (persisted entries have id). Values saved empty do not
    // count, so the manufacturer can still complete them while the fuels wait for confirmation.
    const fuelsFromInit = initialValues.get(fuelsUsedFormFields.TYPES);
    const usedFuelsFromInit = fuelsFromInit
      ? fuelsFromInit.filter((f) => f.get(fuelsUsedFormFields.IS_FUEL_USED))
      : null;
    const ghgAlreadySaved = !!(
      usedFuelsFromInit &&
      usedFuelsFromInit.size > 0 &&
      usedFuelsFromInit.every((f) => {
        const ghgs = f.get(fuelsUsedFormFields.MEASUREMENT_POINT_FUEL_GHGS);
        return (
          ghgs &&
          ghgs.size > 0 &&
          ghgs.every(
            (g) =>
              g.get('id') != null &&
              String(g.get('ghgIntensity') ?? '').trim() !== ''
          )
        );
      })
    );
    const canEditGhg = isOpen || (status === 'PENDING' && !ghgAlreadySaved);

    const meteringPointId = productionUnit.get(
      productionUnitFields.METERING_POINT_ID
    );
    const measurementPointType = productionUnit.get(
      productionUnitFields.METERING_POINT_TYPE
    );
    const monthlyFuelDataConfirmed = productionUnit.get(
      productionUnitFields.MONTHLY_FUEL_DATA_CONFIRMED
    );
    const monthlyGoIssued = productionUnit.get(
      productionUnitFields.MONTHLY_GO_ISSUED
    );
    const hasMeasurementPoints = allMpAggregatedData.length > 0;
    const allMpDataPresent =
      hasMeasurementPoints && allMpAggregatedData.every((mp) => mp.id != null);
    const allMpConfirmed =
      hasMeasurementPoints && allMpAggregatedData.every((mp) => mp.confirmed);
    const period = dayjs().subtract(1, 'month').format('MM.YYYY');
    let hydrogenOpen = false;
    let hydrogenSubmitted = false;

    if (hydrogenFuelData) {
      const hydrogenStatus = hydrogenFuelData.get('status');
      hydrogenOpen = hydrogenStatus === 'OPEN';
      hydrogenSubmitted =
        hydrogenStatus === 'CONFIRMED' && gosStatus !== issuedGosStatus.FAIL;
    }

    const mpTableColumns = [
      {
        title: t('mpTable.measurementPointCode'),
        dataIndex: 'measurementPointEicz',
        key: 'measurementPointEicz',
      },
      {
        title: t('mpTable.producedMwh'),
        dataIndex: 'producedAmount',
        key: 'producedAmount',
        render: (val) => (val == null ? '0' : val),
      },
      {
        title: t('mpTable.producedM3'),
        dataIndex: 'producedVolume',
        key: 'producedVolume',
        render: (val) => (val == null ? '0' : val),
      },
      {
        title: t('mpTable.prevMonthReminder'),
        dataIndex: 'prevMonthReminder',
        key: 'prevMonthReminder',
        render: (val) => (val == null ? '0' : val),
      },
      {
        title: t('mpTable.status'),
        key: 'dataStatus',
        render: (_, record) => {
          const hasData = record.id != null;
          return hasData
            ? t('mpTable.statusDataLoaded')
            : t('mpTable.statusWaitingData');
        },
      },
    ];

    return (
      <Spin spinning={saving}>
        <Form
          initialValues={initialValues.toJS()}
          initialValuesEqual={isEqual}
          keepDirtyOnReinitialize={!isEditMode}
          mutators={{ ...arrayMutators }}
          onSubmit={this.onSubmit}
          render={({
            handleSubmit,
            submitting,
            submitFailed,
            submitError,
            submitCount,
          }) => (
            <form onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_FUELS_USED} />
              <SubmitErrorToast
                submitFailed={submitFailed}
                submitError={submitError}
                submitCount={submitCount}
              />
              <Row>
                <Col span={12}>
                  <h2>
                    {isHydrogenContext
                      ? t('fuelsUsed.hydrogen_title')
                      : t('fuelsUsed.title')}
                  </h2>
                  <p>{t('production_period') + ': ' + period}</p>
                  <div className={`status_${this.getStatus()}`}>
                    {t('status')}: {t(this.getStatus())}
                  </div>
                </Col>
                <Col span={12}>
                  <FuelsUsedHistory
                    t={t}
                    productionUnitId={productionUnit.get(
                      productionUnitFields.ID
                    )}
                    isHydrogenContext={isHydrogenContext}
                  />
                </Col>
              </Row>

              <br />
              <br />

              {!isHydrogenContext && !isAdmin && status === 'PENDING' && (
                <Alert
                  message={t('fuelsUsed.pendingConfirmationInfo')}
                  type="warning"
                  style={{ marginBottom: 16 }}
                />
              )}

              {!isHydrogenContext && (
                <FieldArray
                  name={fuelsUsedFormFields.TYPES}
                  component={FuelUnit}
                  unitId={productionUnit.get(productionUnitFields.ID)}
                  t={t}
                  locale={locale}
                  isLoading={isLoading}
                  fetchClassifiers={fetchClassifiers}
                  inEditForNotAdmin={inEditForNotAdmin}
                  totalPercentage={totalPercentage}
                  isAdmin={isAdmin}
                  monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                  monthlyGoIssued={monthlyGoIssued}
                  isOpen={isOpen}
                />
              )}

              {!isHydrogenContext && isEditMode && hasMeasurementPoints && (
                <MeasurementPointGhgTable
                  measurementPoints={allMpAggregatedData}
                  t={t}
                  isOpen={canEditGhg}
                  monthlyFuelDataConfirmed={monthlyFuelDataConfirmed}
                  monthlyGoIssued={monthlyGoIssued}
                />
              )}

              {isHydrogenContext && (
                <div style={{ display: 'inline-block' }}>
                  <Row gutter={16}>
                    <Col span={12} className="pr-2">
                      <p>{t('fuelsUsed.lowerCalorificValueKg')}</p>
                      <Field
                        name="hydrogenLowerValue"
                        component={NumberField}
                        disabled={isAdmin ? hydrogenSubmitted : !hydrogenOpen}
                        step={0.1}
                        precision={1}
                        min={0}
                        isFloat
                        style={{ width: '100%' }}
                        parse={(v) =>
                          v === '' || v == null ? undefined : Number(v)
                        }
                      />
                    </Col>
                    <Col span={12} className="pr-2">
                      <p>{t('fuelsUsed.higherCalorificValueKg')}</p>
                      <Field
                        name="hydrogenHigherValue"
                        component={NumberField}
                        disabled={isAdmin ? hydrogenSubmitted : !hydrogenOpen}
                        step={0.1}
                        precision={1}
                        min={0}
                        isFloat
                        style={{ width: '100%' }}
                        parse={(v) =>
                          v === '' || v == null ? undefined : Number(v)
                        }
                      />
                    </Col>
                  </Row>
                  <Row gutter={16} style={{ marginTop: 8 }}>
                    <Col span={24} className="pr-2">
                      <p>{t('fuelsUsed.hydrogenChgIntensity')}</p>
                      <Field
                        name="hydrogenChgIntensity"
                        component={NumberField}
                        disabled={isAdmin ? hydrogenSubmitted : !hydrogenOpen}
                        step={0.01}
                        precision={2}
                        min={0}
                        isFloat
                        style={{ width: '100%' }}
                        parse={(v) =>
                          v === '' || v == null ? undefined : Number(v)
                        }
                      />
                    </Col>
                  </Row>
                </div>
              )}

              <div>
                {!isHydrogenContext &&
                  meteringPointId &&
                  measurementPointType === 'PRODUCTION' &&
                  productionUnit.get(
                    productionUnitFields.ACTIVE_MEASUREMENT_POINT_COUNT
                  ) === 1 && (
                    <Link
                      className="production-point__goto-unit pull-left"
                      to={`/meteringPoint/${meteringPointId}/data`}
                    >
                      {t('meteringPointDataStatisticsLink')}
                    </Link>
                  )}

                <RegisterActions
                  hasPrevious={hasPrevious}
                  hasDone={hasDone}
                  isEditMode={isEditMode}
                  isAdmin={isAdmin}
                  isOpen={isOpen}
                  showRequestChangeModal={showRequestChangeModal}
                  goPrevious={goPrevious}
                  showSaveButton={
                    isAdmin || !isEditMode || (!isAdmin && status === 'PENDING')
                  }
                  saveButtonDisabled={
                    (!isHydrogenContext && isEditMode && !canEditGhg) ||
                    (monthlyFuelDataConfirmed && monthlyGoIssued) ||
                    isLoading ||
                    (isHydrogenContext &&
                      (!hydrogenLowerValue ||
                        !hydrogenHigherValue ||
                        !hydrogenChgIntensity))
                  }
                  goNext={
                    isHydrogenContext
                      ? this.updateHydrogenFuelDataAndGoNext
                      : null
                  }
                  t={t}
                  isHydrogenContext={isHydrogenContext}
                  isFuelsUsedStep
                  hydrogenLowerValue={hydrogenLowerValue}
                  hydrogenHigherValue={hydrogenHigherValue}
                />

                {!isAdmin && !isHydrogenContext && isOpen && (
                  <div className="component-register-actions">
                    <Button
                      size="large"
                      type="primary"
                      htmlType="submit"
                      disabled={submitting}
                    >
                      {t('confirmFuelUpdateBtn')}
                    </Button>
                  </div>
                )}

                {isHydrogenContext && !isAdmin && (
                  <div className="component-register-actions">
                    <Button
                      size="large"
                      type="primary"
                      onClick={this.updateHydrogenFuelData}
                      disabled={!hydrogenOpen}
                    >
                      {t('confirmFuelUpdateBtn')}
                    </Button>
                  </div>
                )}

                {isAdmin && isHydrogenContext && (
                  <div className="component-register-actions">
                    <Button
                      size="large"
                      type="primary"
                      onClick={this.updateHydrogenFuelData}
                      disabled={hydrogenSubmitted}
                    >
                      {t('button_save')}
                    </Button>
                  </div>
                )}
              </div>

              {!isHydrogenContext && hasMeasurementPoints && (
                <div>
                  <h3>{t('mpTable.title')}</h3>
                  <Table
                    columns={mpTableColumns}
                    dataSource={allMpAggregatedData}
                    rowKey={(record) =>
                      record.measurementPointId || record.measurementPointEicz
                    }
                    pagination={false}
                    loading={allMpDataLoading}
                    size="small"
                    style={{ marginBottom: 16 }}
                  />
                  <Button
                    size="large"
                    type="primary"
                    onClick={this.confirmAllMeteringPointAmounts}
                    disabled={!allMpDataPresent || allMpConfirmed}
                  >
                    {t('meteringPointAmountsConfirm')}
                  </Button>
                </div>
              )}

              {gosStatus && gosStatus !== issuedGosStatus.NA && (
                <Alert
                  key={gosStatus}
                  style={{ marginTop: 20 }}
                  message={
                    gosStatus === issuedGosStatus.SUCCESS
                      ? t('goSuccess')
                      : t('goFailure')
                  }
                  type={
                    gosStatus === issuedGosStatus.SUCCESS ? 'success' : 'error'
                  }
                />
              )}
            </form>
          )}
        />
      </Spin>
    );
  }
}

const valueSelector = formValueSelector(FORM_FUELS_USED);

const getIsLoading = getLoadingSelector(getLoadingUnitFuels);

const mapStateToProps = (state, ownProps) => {
  const fuels = valueSelector(state, fuelsUsedFormFields.TYPES);
  const isGosIssued = getIsGosIssued(state);
  const issuedGosStatus = isGosIssued?.toJS().data?.status;

  const hydrogenHigherValue = valueSelector(state, 'hydrogenHigherValue');
  const hydrogenLowerValue = valueSelector(state, 'hydrogenLowerValue');
  const hydrogenChgIntensity = valueSelector(state, 'hydrogenChgIntensity');

  const totalPercentage = fuels
    ? fuels
        .filter((f) => f.get(fuelsUsedFormFields.IS_FUEL_USED))
        .reduce(
          (sum, x) =>
            sum + parseInt(x.get(fuelsUsedFormFields.PERCENTAGE, 0), 10),
          0
        )
    : 0;

  const savedFormValues = getRffFormValues(state, FORM_FUELS_USED);

  return {
    hydrogenHigherValue,
    hydrogenLowerValue,
    hydrogenChgIntensity,
    productionUnit: ownProps.productionUnit,
    initialValues: addInitialFuels(ownProps.productionUnit, state),
    savedFormValues: savedFormValues?.toJS ? savedFormValues.toJS() : {},
    locale: getLocale(state),
    totalPercentage,
    fuels,
    hydrogenFuelData: getHydrogenFuelData(state),
    isLoading: getIsLoading(state),
    measurementData: getHydrogenMeasurementData(state),
    gosStatus: issuedGosStatus,
  };
};

const mapDispatchToProps = {
  fetchClassifiers: fetchFeedstockAndProductionPathwayClassifiers,
  fetchHydrogenFuelDataForProductionPeriod:
    fetchHydrogenFuelDataForProductionPeriod,
  fetchHydrogenMeasurementDataForProductionPeriod:
    fetchHydrogenMeasurementDataForProductionPeriod,
  isGosIssued: fetchHydrogenGosIssued,
  issueHydrogenGos: issueHydrogenGos,
  resetGosIssued: resetHydrogenGosIssued,
  updateFuelsWithDelete,
  requestProductionUnitUpdate,
  fetchProductionUnit: fetchAndEditProductionUnitNoHistory,
  updateFormState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEquipmentFuelsUsed);
